// extracted by mini-css-extract-plugin
module.exports = {"error-response":"server_errors__error-response___34Lrk","errorResponse":"server_errors__error-response___34Lrk"};